import { CircularProgress } from '@mui/material';
import { format } from 'date-fns';

import { InvoiceSummaryDto } from 'src/generated/services/TFinancialApi';
import { useGetActivityLogs } from 'src/use-cases/invoice/useInvoices';
import { LogItem } from './LogItem';

interface IModalContentProps {
  invoiceSummary: InvoiceSummaryDto;
}

export const ActivityLogModalContent: React.FC<IModalContentProps> = (props) => {
  const { invoiceSummary } = props;
  const { data: logs, isLoading } = useGetActivityLogs(invoiceSummary?.id);
  const lastLog = logs?.length > 0 ? logs.at(-1) : null;

  return (
    <div className='relative'>
      <h3 className='text-16 font-medium mb-2'>Activity Log For Invoice No. {invoiceSummary?.invoiceNumber}</h3>
      {lastLog && <p className='text-14 text-blue_grey-80'>Updated {format(new Date(lastLog?.createdOn), 'dd-MMM-yyyy hh.mm.aaaa')}</p>}

      <div className='mt-24 border border-neutral-20 rounded-8 p-24'>
        {isLoading ? (
          <div className='flex items-center justify-center'>
            <CircularProgress color='primary' />
          </div>
        ) : (
          <>
            {logs.map((log) => (
              <LogItem log={log} key={`log-${log?.createdOn}-${log?.activityType}-${log?.actionBy}`} />
            ))}
          </>
        )}
      </div>
    </div>
  );
};
